module.exports = __webpack_public_path__ + "media/preview/recruitment@3x-09a49682.png";